"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.typed.uint8-array");
var _objectSpread2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.split");
var _regeneratorRuntime2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.function.name");
var _applicationStore = require("../../api/applicationStore.js");
var _apprepair = require("../../api/apprepair.js");
var _upload = require("../../api/upload.js");
var _app = require("../../api/app.js");
var _awsSdk = _interopRequireDefault(require("aws-sdk"));
var _axios = _interopRequireDefault(require("axios"));
var _browserMd5File = _interopRequireDefault(require("browser-md5-file"));
var _aliOss = _interopRequireDefault(require("ali-oss"));
var _jsMd = _interopRequireDefault(require("js-md5"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ApplicationStore',
  data: function data() {
    return {
      isDisable: false,
      isFlag: true,
      dialogFormVisible: false,
      tableData: [],
      currentRow: null,
      total: 0,
      currentPage: 1,
      loading: false,
      isRepeat: false,
      lines: [{
        line: "0",
        label: "上线"
      }, {
        line: "1",
        label: "下线"
      }],
      param: {
        line: "",
        version: "",
        name: "",
        pageNo: 1,
        pageSize: 10
      },
      formLabelWidth: "120px",
      buttonUpload: "点击上传",
      saveButton: "保存",
      disab: false,
      savedisab: true,
      uploadloading: false,
      dialogFormVisibles: false,
      type: [],
      form: {
        languageList: [],
        name: "",
        cnName: "",
        jpName: "",
        hkName: "",
        packageName: "",
        version: "",
        versionNo: "",
        iconUrl: "",
        awsIconurl: "",
        equipmentModelList: [],
        equipmentPurposeList: [],
        firmwareVersion: [],
        size: "",
        md5: "",
        innerName: ""
      },
      equipmentModelList: [],
      equipmentPurposeList: [],
      firmwareVersion: [],
      id: "",
      show: false,
      imageUrl1: "",
      changeform: {
        language: [],
        equipmentModel: [],
        equipmentPurpose: [],
        firmwareVersion: ""
      },
      changeid: "",
      name: "",
      version: "",
      fileData: null,
      value: null,
      privateKey_1: "XAkWgD0A",
      privateKey_2: "KSVDWG",
      progress: 0,
      keyId: "K66NRBmhuzqh6QX36ICAKIAVT4",
      secretId: "zlMc+UDjkbfloun7DrYRHfJQNupFNQfZuKHd49NL8jqu2x",
      ufileKeyId: "DZ6AMdbKW54tdbbnzqikFxwHYPAJ4ZDugctlNo9",
      ufileSecretId: "DY2OpDusgX65jFGrbqcqs9bCLLp6DkpenI6VCxKzZ7pRlO6Hdt",
      md5: ""
    };
  },
  //刷新
  created: function created() {
    this.getList();
  },
  mounted: function mounted() {
    var _this = this;
    (0, _apprepair.getLanList)({
      name: "lan"
    }).then(function (res) {
      _this.type = res.dictionaryVOList;
    });
  },
  methods: {
    //点击获取当前点击行的数据
    getRow: function getRow(row) {
      this.currentRow = row;
      this.id = row.id;
    },
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      setTimeout(function () {
        (0, _applicationStore.getLists)(_this2.param).then(function (res) {
          _this2.tableData = res.voList;
          _this2.total = res.total;
          _this2.loading = false;
        });
      }, 1000);
    },
    //每页显示的条数
    changepage: function changepage(currentPage) {
      this.currentPage = currentPage;
      this.param.pageNo = currentPage;
      this.getList();
    },
    //根据参数进行查询
    search: function search() {
      var _this3 = this;
      this.loading = true;
      setTimeout(function () {
        (0, _applicationStore.getLists)({
          line: _this3.param.line,
          version: _this3.param.version,
          name: _this3.param.name,
          pageNo: 1,
          pageSize: 10
        }).then(function (res) {
          _this3.tableData = res.voList;
          _this3.total = res.total;
          _this3.currentPage = 1;
          _this3.loading = false;
        });
      }, 1000);
    },
    //判断上下线
    line: function line(row) {
      if (row.line == "0") {
        return "上线";
      } else if (row.line == "1") {
        return "下线";
      }
    },
    //清空
    empty: function empty() {
      this.param.line = "";
      this.param.version = "";
      this.param.name = "";
      this.current = null;
      this.currentPage = 1;
      this.form.pageNo = 1;
      this.getList();
    },
    msgTip: function msgTip(msgType, msgInfo) {
      this.$message({
        type: msgType,
        message: msgInfo,
        center: true
      });
    },
    handleClick: function handleClick(val) {
      this.current = val;
    },
    //上传icon
    beforeUploadPicture1: function beforeUploadPicture1(file) {
      var _this4 = this;
      if (!(file.type === "image/png" || file.type === "image/gif" || file.type === "image/jpg" || file.type === "image/svg+xml" || file.type === "image/jpeg")) {
        this.msgTip("warning", "请上传格式为png, gif, jpg, jpeg, svg的图片");
        return false;
      }
      var fd = new FormData();
      fd.append("file", file);
      this.uploadloading = true;
      var req = new XMLHttpRequest();
      req.open("GET", document.location, false);
      req.send(null);
      var userType = req.getResponseHeader("Domain") ? req.getResponseHeader("Domain") : "";

      // 判断是否为 SVG 文件
      var isSVG = file.type === "image/svg+xml" || file.name.toLowerCase().endsWith('.svg');

      // 统一处理上传成功
      var handleSuccess = function handleSuccess(res) {
        if (res.success) {
          var url = res.voT.downloadUrl;

          // 如果是 SVG 文件，使用特殊处理
          if (isSVG) {
            _this4.handleSVGDisplay(url, file, res);
          } else {
            // 非 SVG 文件使用原有逻辑
            _this4.imageUrl1 = url + '?t=' + new Date().getTime();
            _this4.form.iconUrl = url;
            _this4.form.awsIconurl = url;
            _this4.uploadloading = false;
            if (_this4.form.packageName !== "") {
              _this4.savedisab = false;
              if (_this4.$refs.uploadFile) {
                _this4.$refs.uploadFile.value = null;
              }
            }
            _this4.$nextTick(function () {
              _this4.$forceUpdate();
            });
          }
        } else {
          _this4.savedisab = true;
          _this4.buttonUpload = "点击上传";
          _this4.uploadloading = false;
        }
      };
      if (userType == "cn") {
        (0, _upload.ufileUpload)(fd).then(function (res) {
          handleSuccess(res);
        }).catch(function (error) {
          console.error('上传错误:', error);
          _this4.uploadloading = false;
        });
        return false;
      } else {
        (0, _upload.awsUpload)(fd).then(function (res) {
          handleSuccess(res);
        }).catch(function (error) {
          console.error('上传错误:', error);
          _this4.uploadloading = false;
        });
        return false;
      }
    },
    // 新增方法：处理 SVG 显示（针对 OSS Content-Type 错误）
    handleSVGDisplay: function () {
      var _handleSVGDisplay = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(url, originalFile, res) {
        var _this5 = this;
        var svgDataUrl, response, svgText, dataUrl;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.readFileAsDataURL(originalFile);
            case 3:
              svgDataUrl = _context.sent;
              // 显示 SVG
              this.imageUrl1 = svgDataUrl;
              this.form.iconUrl = url; // 表单中仍保存原始 URL
              this.form.awsIconurl = url;
              this.uploadloading = false;
              if (this.form.packageName !== "") {
                this.savedisab = false;
                if (this.$refs.uploadFile) {
                  this.$refs.uploadFile.value = null;
                }
              }
              this.$nextTick(function () {
                _this5.$forceUpdate();
              });
              _context.next = 44;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              console.error('SVG 处理失败:', _context.t0);

              // 方法2: 如果方法1失败，尝试使用 fetch（但可能因 Content-Type 问题失败）
              _context.prev = 15;
              _context.next = 18;
              return fetch(url);
            case 18:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 31;
                break;
              }
              _context.next = 22;
              return response.text();
            case 22:
              svgText = _context.sent;
              dataUrl = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgText)));
              this.imageUrl1 = dataUrl;
              this.form.iconUrl = url;
              this.form.awsIconurl = url;
              this.uploadloading = false;
              if (this.form.packageName !== "") {
                this.savedisab = false;
                if (this.$refs.uploadFile) {
                  this.$refs.uploadFile.value = null;
                }
              }
              _context.next = 32;
              break;
            case 31:
              throw new Error('Fetch 请求失败');
            case 32:
              _context.next = 43;
              break;
            case 34:
              _context.prev = 34;
              _context.t1 = _context["catch"](15);
              console.error('Fetch 也失败:', _context.t1);

              // 方法3: 最终回退方案 - 使用原始 URL 但尝试不同的显示方式
              this.imageUrl1 = url + '?t=' + new Date().getTime();
              this.form.iconUrl = url;
              this.form.awsIconurl = url;
              this.uploadloading = false;
              if (this.form.packageName !== "") {
                this.savedisab = false;
                if (this.$refs.uploadFile) {
                  this.$refs.uploadFile.value = null;
                }
              }

              // 提示用户可能需要手动刷新
              this.msgTip("warning", "SVG 文件已上传，但显示可能有问题，请尝试刷新页面");
            case 43:
              this.$nextTick(function () {
                _this5.$forceUpdate();
              });
            case 44:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 12], [15, 34]]);
      }));
      function handleSVGDisplay(_x, _x2, _x3) {
        return _handleSVGDisplay.apply(this, arguments);
      }
      return handleSVGDisplay;
    }(),
    // 新增辅助方法：将文件读取为 Data URL
    readFileAsDataURL: function readFileAsDataURL(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
          return resolve(e.target.result);
        };
        reader.onerror = function (e) {
          return reject(new Error('文件读取失败'));
        };
        reader.readAsDataURL(file);
      });
    },
    //上传
    upload: function upload() {
      var _this6 = this;
      this.dialogFormVisible = true;
      this.progress = 0;
      (0, _apprepair.getLanList)({
        name: "EQUIPMENT_MODEL",
        value: ""
      }).then(function (res) {
        _this6.equipmentModelList = res.dictionaryVOList;
      });
      (0, _apprepair.getLanList)({
        name: "EQUIPMENT_PURPOSE",
        value: ""
      }).then(function (res) {
        _this6.equipmentPurposeList = res.dictionaryVOList;
      });
      (0, _applicationStore.getTaskversion)().then(function (res) {
        _this6.firmwareVersion = res.voList;
      });
    },
    submitUpload: function submitUpload() {
      var _this7 = this;
      this.fileData = this.$refs.uploadFile.files[0];
      var formFile = new FormData(); //加入文件对象
      formFile.append("file", this.fileData);
      if (this.buttonUpload != "点击上传") {
        return;
      }
      var index = this.fileData.name.lastIndexOf(".");
      var str = this.fileData.name.substring(index + 1, this.fileData.name.length);
      var extension = str === "apk";
      if (!extension) {
        this.msgTip("error", "上传固件只能是apk格式!");
        return;
      } else {
        this.loading = true;
        (0, _applicationStore.searchApp)(formFile).then(function (res) {
          if (res.success) {
            _this7.show = true;
            _this7.form.name = res.voT.name;
            _this7.form.cnName = res.voT.cnName;
            _this7.form.jpName = res.voT.jpName;
            _this7.form.hkName = res.voT.hkName;
            _this7.form.packageName = res.voT.packageName;
            _this7.form.version = res.voT.version;
            _this7.form.versionNo = res.voT.versionNo;
            _this7.loading = false;
            if (_this7.form.iconUrl !== "" && _this7.form.awsIconurl !== "") {
              _this7.disab = true;
              _this7.savedisab = false;
              _this7.$refs.uploadFile.value = null;
              _this7.buttonUpload = res.voT.name;
            }
          } else {
            _this7.loading = false;
            _this7.msgTip("error", res.errorMsg);
            _this7.$refs.uploadFile.value = null;
          }
        });
      }
    },
    submitUpload_1: function submitUpload_1() {
      var _this8 = this;
      this.fileData = this.$refs.uploadFile.files[0];
      var formFile = new FormData(); //加入文件对象
      formFile.append("file", this.fileData);
      if (this.buttonUpload != "点击上传") {
        return;
      }
      var index = this.fileData.name.lastIndexOf(".");
      var str = this.fileData.name.substring(index + 1, this.fileData.name.length);
      var extension = str === "apk";
      if (!extension) {
        this.msgTip("error", "上传固件只能是apk格式!");
        return;
      } else {
        this.loading = true;
        (0, _applicationStore.searchApp)(formFile).then(function (res) {
          if (res.success) {
            _this8.show = true;
            _this8.form.name = res.voT.name;
            _this8.form.packageName = res.voT.packageName;
            _this8.form.version = res.voT.version;
            _this8.form.versionNo = res.voT.versionNo;
            _this8.loading = false;
            if (_this8.form.iconUrl !== "" && _this8.form.awsIconurl !== "") {
              _this8.disab = true;
              _this8.savedisab = false;
              _this8.$refs.uploadFile.value = null;
              _this8.buttonUpload = res.voT.name;
            }
          } else {
            _this8.loading = false;
            _this8.msgTip("error", res.errorMsg);
            _this8.$refs.uploadFile.value = null;
          }
        });
      }
    },
    save: function save() {
      var _this9 = this;
      if (this.form.equipmentModelList == []) {
        this.msgTip("warning", "请选择设备型号");
      } else if (this.form.equipmentPurposeList == []) {
        this.msgTip("warning", "请选择设备用途");
      } else if (this.form.firmwareVersion == []) {
        this.msgTip("warning", "请选择固件版本号");
      } else {
        if (this.savedisab == true) {
          return;
        }
        this.savedisab = true;
        this.saveButton = "正在保存";
        this.isRepeat = true;
        var req = new XMLHttpRequest();
        req.open("GET", document.location, false);
        req.send(null);
        var userType = req.getResponseHeader("Domain") ? req.getResponseHeader("Domain") : "";
        this.form.size = this.fileData.size;
        this.form.packageName + Math.floor(100000 + Math.random() * 900000);
        this.getFileMD5(this.fileData).then(function (md5) {
          _this9.form.md5 = md5;
          (0, _app.appAapply)({
            fileName: _this9.fileData.name,
            folder: "1"
          }).then(function (res) {
            if (res.success) {
              _this9.fileNames = res.s3Url.substr(res.s3Url.lastIndexOf("/", res.s3Url.lastIndexOf("/") - 1) + 1);
              _this9.form.innerName = _this9.fileNames;
              if (userType == "cn") {
                var data = {
                  file: _this9.fileData,
                  fileRename: _this9.fileNames
                };
                //ali云上传
                console.log("ali云上传");
                var _accessKeyId = _this9.decryption(res.accessKeyId);
                var accessKeySecret = _this9.decryption(res.accessKeySecret);
                var bucket = res.bucketName;
                var clientOssAli = new _aliOss.default({
                  accessKeyId: _accessKeyId,
                  accessKeySecret: accessKeySecret,
                  bucket: bucket,
                  endpoint: "supernote.com.cn"
                });
                var innerName1 = _this9.fileNames;
                console.log(innerName1);
                //调用阿里云Oss上传方法
                _this9.startUpload(_this9.fileData, clientOssAli, innerName1);
              } else {
                console.log("aws 云上传");
                var decryptedPart1 = _this9.keyId.slice(-7);
                var decryptedPart2 = _this9.keyId.slice(-14, -7).split("").reverse().join("");
                var decryptedPart3 = _this9.keyId.slice(0, -14).slice(0, -6).split("").reverse().join("");
                var accessKeyId = decryptedPart1 + decryptedPart2 + decryptedPart3;
                var secretdecryptedPart1 = _this9.secretId.slice(-15);
                var secretdecryptedPart2 = _this9.secretId.slice(-31, -15).split("").reverse().join("");
                var secretreversedPart3 = _this9.secretId.slice(0, -31).slice(0, -6).split("").reverse().join("");
                var secretAccessKey = secretdecryptedPart1 + secretdecryptedPart2 + secretreversedPart3;
                var s3 = new _awsSdk.default.S3({
                  accessKeyId: accessKeyId,
                  secretAccessKey: secretAccessKey,
                  region: "ap-northeast-1"
                });
                var _bucket = res.bucketName;
                var contentType = "application/vnd.android.package-archive";
                var params = {
                  Bucket: _bucket,
                  Key: _this9.fileNames,
                  ContentType: contentType,
                  ACL: "public-read"
                };
                s3.getSignedUrl("putObject", params, function (error, url) {
                  if (error) {
                    console.error("获取预签名URL失败：", error);
                    return;
                  }
                  var xhr = new XMLHttpRequest();
                  xhr.open("PUT", url, true);
                  xhr.setRequestHeader("Content-Type", contentType);
                  xhr.upload.addEventListener("progress", function (event) {
                    if (event.lengthComputable) {
                      console.log("上传进度:", Math.round(event.loaded / event.total * 100));
                      _this9.progress = Math.round(event.loaded / event.total * 100);
                      if (event.loaded / event.total * 100 == 100) {}
                    }
                  });
                  xhr.onreadystatechange = function () {
                    if (xhr.readyState === XMLHttpRequest.DONE) {
                      if (xhr.status === 200) {
                        console.info("文件上传成功");
                        _this9.saveSuccess();
                      } else {
                        console.error("文件上传失败：", xhr.statusText);
                      }
                    }
                  };
                  xhr.send(_this9.fileData);
                });
              }
            }
          });
          // this.loading = true;
        }).catch(function (error) {
          _this9.$refs.uploadFile.value = [];
          console.error("Error calculating MD5:", error);
          _this9.msgTip("error", "MD5计算异常！");
        });
      }
    },
    saveSuccess: function saveSuccess() {
      var _this10 = this;
      (0, _applicationStore.appUpload)(this.form).then(function (res) {
        if (res.success) {
          _this10.msgTip("success", "上传成功");
          _this10.$refs.uploadFile.value = [];
          _this10.disab = false;
          _this10.show = false;
          _this10.saveButton = "保存";
          _this10.buttonUpload = "点击上传";
          _this10.dialogFormVisible = false;
          //this.$refs[form].resetFields();
          _this10.getList();
        } else {
          _this10.msgTip("error", res.errorMsg);
          _this10.$refs.uploadFile.value = [];
          _this10.buttonUpload = "点击上传";
          _this10.saveButton = "保存";
          _this10.savedisab = false;
          _this10.disab = false;
          _this10.isRepeat = false;
        }
      });
    },
    save_1: function save_1() {
      var _this11 = this;
      if (this.form.equipmentModelList == []) {
        this.msgTip("warning", "请选择设备型号");
      } else if (this.form.equipmentPurposeList == []) {
        this.msgTip("warning", "请选择设备用途");
      } else if (this.form.firmwareVersion == []) {
        this.msgTip("warning", "请选择固件版本号");
      } else {
        if (this.savedisab == true) {
          return;
        }
        this.savedisab = true;
        this.saveButton = "正在保存";
        this.isRepeat = true;
        (0, _applicationStore.appUpload)(this.form).then(function (res) {
          if (res.success) {
            _this11.msgTip("success", "上传成功");
            _this11.$refs.uploadFile.value = [];
            _this11.disab = false;
            _this11.show = false;
            _this11.saveButton = "保存";
            _this11.buttonUpload = "点击上传";
            _this11.dialogFormVisible = false;
            //this.$refs[form].resetFields();
            _this11.getList();
          } else {
            _this11.msgTip("error", res.errorMsg);
            _this11.$refs.uploadFile.value = [];
            _this11.buttonUpload = "点击上传";
            _this11.saveButton = "保存";
            _this11.savedisab = false;
            _this11.disab = false;
            _this11.isRepeat = false;
          }
        });
      }
    },
    //阿里云OSS上传
    startUpload: function () {
      var _startUpload = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(fileData, clientOssAli, innerName1) {
        var _this12 = this;
        var result;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return clientOssAli.multipartUpload("/" + innerName1,
              // 目标Bucket中的文件路径
              fileData,
              // 本地文件路径
              {
                progress: function progress(percent) {
                  console.log("\u4E0A\u4F20\u8FDB\u5EA6: ".concat(Math.round(percent * 100), "%"));
                  _this12.progress = Math.round(percent * 100);
                }
              });
            case 3:
              result = _context2.sent;
              console.log("上传成功:", result);
              this.saveSuccess();
              _context2.next = 18;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.error("UploadError:", _context2.t0);
              this.$refs.uploadFile.value = [];
              this.buttonUpload = "点击上传";
              this.saveButton = "保存";
              this.savedisab = false;
              this.disab = false;
              this.isRepeat = false;
              this.msgTip("error", "上传文件失败！");
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 8]]);
      }));
      function startUpload(_x4, _x5, _x6) {
        return _startUpload.apply(this, arguments);
      }
      return startUpload;
    }(),
    // 解密函数
    decryption: function decryption(encryptionStr) {
      if (encryptionStr === null || encryptionStr === "") {
        return encryptionStr;
      }
      var decryptedStr = "";
      var length = Math.ceil(encryptionStr.length / 2);
      for (var i = 0; i < length; i++) {
        var charCode = parseInt(encryptionStr.substring(i * 2, i * 2 + 2), 16) - 1;
        decryptedStr += String.fromCharCode(charCode);
      }
      var startIndex = this.privateKey_1.length;
      var endIndex = decryptedStr.length - this.privateKey_2.length;
      endIndex = Math.max(endIndex, 0);
      return decryptedStr.substring(startIndex, endIndex);
    },
    // 更新上传进度
    updateUploadProgress: function updateUploadProgress(fileName, progressEvent) {
      var progress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
      this.msgList = this.msgList.map(function (item) {
        if (item.fileName === fileName) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
            progress: progress
          });
        }
        return item;
      });
    },
    //计算MD5
    getFileMD5: function () {
      var _getFileMD = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(file) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onload = function () {
                  var buffer = new Uint8Array(reader.result);
                  var hash = (0, _jsMd.default)(buffer);
                  resolve(hash);
                };
                reader.onerror = reject;
                reader.readAsArrayBuffer(file);
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getFileMD5(_x7) {
        return _getFileMD.apply(this, arguments);
      }
      return getFileMD5;
    }(),
    //弹框关闭
    uploadClose: function uploadClose() {
      this.dialogFormVisible = false;
      this.form.languageList = [];
      this.show = false;
      this.buttonUpload = "点击上传";
      this.imageUrl1 = "";
      this.savedisab = true;
      this.disab = false;
      this.form.equipmentModelList = [];
      this.form.equipmentPurposeList = [];
      this.form.firmwareVersion = [];
    },
    //删除
    del: function del() {
      var _this13 = this;
      console.log(this.current, "1231");
      if (this.current == "" || this.current == null || this.current.length < 1) {
        this.msgTip("error", "请选择需要删除的记录!");
        return;
      } else {
        this.$confirm("您是否要删除当前选中的记录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          //进行删除
          (0, _applicationStore.deleList)(_this13.current.id).then(function (res) {
            if (res.success) {
              _this13.$message({
                type: "success",
                message: "操作成功",
                center: true
              });
              _this13.getList();
            } else {
              //删除失败
              _this13.$message({
                type: "error",
                message: res.errorMsg,
                center: true
              });
            }
          });
        });
      }
    },
    //修改
    change: function change(row) {
      var _this14 = this;
      this.changeid = row.id;
      this.dialogFormVisibles = true;
      (0, _apprepair.getLanList)({
        name: "EQUIPMENT_MODEL",
        value: ""
      }).then(function (res) {
        _this14.equipmentModelList = res.dictionaryVOList;
      });
      (0, _apprepair.getLanList)({
        name: "EQUIPMENT_PURPOSE",
        value: ""
      }).then(function (res) {
        _this14.equipmentPurposeList = res.dictionaryVOList;
      });
      (0, _applicationStore.getTaskversion)().then(function (res) {
        _this14.firmwareVersion = res.voList;
      });
      (0, _applicationStore.aloneStore)(row.id).then(function (res) {
        if (res.success) {
          _this14.changeform = res.voT;
          _this14.name = res.voT.name;
          _this14.version = res.voT.version;
        }
      });
    },
    //修改确定
    changesave: function changesave() {
      var _this15 = this;
      if (this.changeform.equipmentMode == []) {
        this.msgTip("warning", "请选择设备型号");
      } else if (this.changeform.equipmentPurpose == []) {
        this.msgTip("warning", "请选择设备用途");
      } else if (this.changeform.firmwareVersion == []) {
        this.msgTip("warning", "请选择固件版本号");
      } else {
        (0, _applicationStore.changeStore)({
          equipmentModelList: this.changeform.equipmentModel,
          equipmentPurposeList: this.changeform.equipmentPurpose,
          firmwareVersion: this.changeform.firmwareVersion,
          languageList: this.changeform.language,
          id: this.changeid
        }).then(function (res) {
          if (res.success) {
            _this15.dialogFormVisibles = false;
            _this15.getList();
            _this15.msgTip("success", "修改成功");
          } else {
            _this15.msgTip("error", res.errorMsg);
          }
        });
      }
    },
    //修改取消
    changeClose: function changeClose() {
      this.dialogFormVisibles = false;
    },
    //上线
    online: function online(v) {
      var _this16 = this;
      if (v.line == "0") {
        this.msgTip("warning", "该数据已上线");
      } else {
        (0, _applicationStore.changeOn)({
          line: 0,
          id: v.id
        }).then(function (res) {
          if (res.success) {
            _this16.msgTip("success", "上线成功");
            _this16.getList();
          } else {
            _this16.msgTip("error", res.errorMsg);
          }
        });
      }
    },
    //下线
    offline: function offline(v) {
      var _this17 = this;
      if (v.line == "1") {
        this.msgTip("warning", "该数据已下线");
      } else {
        (0, _applicationStore.changeOn)({
          line: 1,
          id: v.id
        }).then(function (res) {
          if (res.success) {
            _this17.msgTip("success", "下线成功");
            _this17.getList();
          } else {
            _this17.msgTip("error", res.errorMsg);
          }
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.grayRow = val;
      for (var i = 0; i < val.length; i++) {
        this.adgray.userIdList.push(val[i].userId);
      }
    },
    getInputGray: function getInputGray(event) {
      if (this.gray.telephone != "" || this.gray.email != "") {
        this.graySearchDisabled = false;
      } else {
        this.graySearchDisabled = true;
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    }
  }
};
/**
 * 获取当前时间
 */
function getDate() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  var hours = date.getHours(); //获取当前小时数(0-23)
  var minutes = date.getMinutes(); //获取当前分钟数(0-59)
  var seconds = date.getSeconds();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate + " " + hours + ":" + minutes + ":" + seconds;
  return currentdate;
}